export const VOCABULAR = {
    id: 'ID',
    inn: 'ИНН',
    kpp: 'КПП',
    name: 'ФИО',
    ogrn: 'ОГРН',
    type: 'Тип',
    emails: 'Почта',
    email: 'Почта',
    phones: 'Телефон',
    phone: 'Телефон',
    address: 'Адрес',
    website: 'Сайт',
    director:'Директор',
    bank_name: 'Имя банка',
    created_at: 'Дата создания',
    updated_at: 'Дата редактирования',
    type_director: 'В лице',
    payment_account: 'Лицевой счет',
    correspondent_account: 'Корреспондентский счет',
    reference_company_status_id: 'Статус компании',
    reference_service_property_name: 'Наименование свойства услуги',
    order_service_name: 'Наименование услуги',
    created: 'Создано',
    updated: 'Обновлено',
    deleted: 'Удалено',
    lead_fio: 'ФИО',
    lead_email: 'Почта',
    lead_phone: 'Телефон',
    creator_user_name: 'ФИО создателя',
    creator_user_position: 'Позиция создателя',
    sales_manager_user_name: 'Менеджер SALES',
    sales_manager_user_position: 'Позиция менеджера',
    value: 'Значение',
    company_name: 'Наименование компании',
    reference_sources_name: 'Источник клиента',
    reference_order_type_name: 'Тип процедуры',
    receive_datetime: 'Дата получения заявки',
    processing_end_datetime: 'Дата отработки заявки',
    passport_number: 'Паспорт. Серия и номер',
    passport_file_photo_id: 'Паспорт. Разворот с фото',
    passport_file_address_id: 'Паспорт. Разворот с пропиской',
    passport_address: 'Паспорт. Адрес регистрации',
    passport_issued_by: 'Паспорт. Кем выдан',
    passport_issued_date: 'Паспорт. Дата выдачи',
    passport_birth_date: 'Паспорт. Дата рождения',
    passport_birth_town: 'Паспорт. Город рождения',
    passport_checked_id: 'Паспорт. ID статуса проверки',
    driver_card_number: 'ВУ. Серия и номер',
    driver_card_file_face_id: 'ВУ. Фото лицевой стороны',
    driver_card_ends_at: 'ВУ. Дата окончания действия',
    driver_card_checked_id: 'ВУ. ID статуса проверки',
    driver_card_file_back_id: 'ВУ. Фото оборотной стороны',
    phone_additional: 'Добавочный телефон',
    brand: 'Марка и модель',
    year: 'Год',
    number: 'Гос. номер',
    ctc_number: 'СТС. Серия и номер',
    ctc_file_face_id: 'СТС. Фото лицевой стороны',
    ctc_file_back_id: 'СТС. Фото оборотной стороны',
    ptc_number: 'ПТС. Серия и номер',
    ptc_file_face_id: 'ПТС. Фото лицевой стороны',
    ptc_file_back_id: 'ПТС. Фото оборотной стороны',
    owner: 'Собственность (1 - да, 0 - нет)',
    rent_number: 'Договор аренды. Номер договора',
    rent_file_id: 'Договор аренды. Скан',
    reference_truck_type_id: 'Тип ТС',
    reference_truck_body_type_id: 'Вид кузова',
    type_of_loading: 'Тип загрузки',
    dimensions_length: 'Длина кузова',
    dimensions_width: 'Ширина кузова',
    dimensions_height: 'Высота кузова',
    dimensions_volume: 'Объем кузова',
    carrying: 'Грузоподъемность',
    checked_id: 'ID статуса проверки ТС',
    motivation_only_escort: 'Считать только сопровождение в мотивации',
    motivation_block_all: 'Полная блокировка расчета мотивации',
    reference_sources_id: 'Источника заказа',
    reference_friend_type_id: 'Тип компании',
    teo_manager_user_id: 'Менеджер по ведению ТЭО',
    is_transport_company: 'Транспортная компания',
    is_b2c_rezident: 'Компания-резидент B2C',
    sales_manager_user_id: 'Менеджер SALES',
    to_manager_user_id: 'Менеджер по ведению ВЭД',
    set_services_ids: 'Сегменты услуг компании',
    in_russia: 'Внутрироссийския компания',
    reference_property_country_id: 'Страна',
    reference_property_country_name: 'Страна',
    reference_company_status_name: 'Статус компании',
    teo_manager_user_name: 'Менеджер по ведению ТЭО',
    to_manager_user_name: 'Менеджер по ведению ВЭД',
    reference_friend_type_name: 'Тип компании',
    decline_type_reference_property_id: 'Причина отказа',
    decline_type_name: 'Причина отказа',
    checked_name: 'Статус проверки',
    creator_user_id: 'Создатель',
    address_fact: 'Фактический адрес',
    date_of_opening: 'Дата открытия',
    deleted_at: 'Дата удаления',
    sales_status: 'Статус продаж',
    percent_of_mp_to_calc: 'Процент в МП',
    b2c_alias: 'Алиас B2C',
    parent_id: 'ID головной компании',
    seasonable: 'Сезонность',
    type_of_transport_company: 'Тип транспортной компании',
    year_certificate_of_residency: 'Год сертификата резидентства',
    external_sales_manager_name: 'Внешний менеджер SALES',
    bitrix_company_id: 'ID компании в Bitrix',
}

export const SERVICE_TO_DOCUMENT = {
    22: 329,    // ТО
    23: 330,    // ТЭО
    24: '331,329',    // Сертификация
    25: 332,     // Консалтинг
    75: '329,330', // ПНК
    76: '329,330', // СВХ
    77: '329,330'  // Страхование
    // , 75, 76, 77
}
